var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#1A446F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1594_11411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 18,
    height: 18,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1594_11411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5H16.5V15H10.5V16.5ZM10.5 14.25H19.5V12.75H10.5V14.25ZM10.5 12H19.5V10.5H10.5V12ZM7.5 22.5V9C7.5 8.5875 7.64688 8.23438 7.94063 7.94063C8.23438 7.64688 8.5875 7.5 9 7.5H21C21.4125 7.5 21.7656 7.64688 22.0594 7.94063C22.3531 8.23438 22.5 8.5875 22.5 9V18C22.5 18.4125 22.3531 18.7656 22.0594 19.0594C21.7656 19.3531 21.4125 19.5 21 19.5H10.5L7.5 22.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.53d9b384dea37e7bc17b6ffff98553b9.svg";
export { ForwardRef as ReactComponent };